import { SVLabeledText, SVSummaryCard } from '@/components/core';
import { BankApplicationDetails } from '@/types/bankApplications';
import { formatDateTimeFromUTC } from '@/utils/date';
import { Card, Stack, Typography } from '@mui/material';

type BankApplicationSignaturesProps = {
  bankApplication: BankApplicationDetails;
};

export default function BankApplicationSignatures({
  bankApplication,
}: BankApplicationSignaturesProps) {
  const { allOwnersViewedSignatureRequests, owners } = bankApplication;

  return (
    <Card>
      <Stack spacing={2}>
        <Typography variant="h5">Owner Signatures ({owners.length})</Typography>
        <SVLabeledText
          label="Have all owners viewed the application?"
          text={allOwnersViewedSignatureRequests ? 'Yes' : 'No'}
        />
        {owners.map(owner => {
          const {
            consumer,
            isPrimaryOwner,
            sentSignatureRequestAt,
            signatureRequestFirstViewedAt,
            signedAt,
          } = owner;

          return (
            <SVSummaryCard
              key={consumer.uuid}
              label={`${consumer.fullName} (${consumer.email})`}
              items={[
                {
                  label: 'Is Primary Owner',
                  text: isPrimaryOwner ? 'Yes' : 'No',
                },
                {
                  label: 'Sent Signature Request At',
                  text: sentSignatureRequestAt
                    ? formatDateTimeFromUTC(sentSignatureRequestAt, true)
                    : 'N/A',
                },
                {
                  label: 'Viewed Signature Request At',
                  text: signatureRequestFirstViewedAt
                    ? formatDateTimeFromUTC(signatureRequestFirstViewedAt, true)
                    : 'N/A',
                },
                {
                  label: 'Signed At',
                  text: signedAt
                    ? formatDateTimeFromUTC(signedAt, true)
                    : 'N/A',
                },
              ]}
            />
          );
        })}
      </Stack>
    </Card>
  );
}
